export const levels = [{
	cards: [
		"✈",
		"♘",
		"✈",
		"♫",
		"♫",
		"☆",
		"♘",
		"☆"		],
	difficulty: "easy"
},
{
	cards: [
		"❄",
		"⍨",
		"♘",
		"✈",
		"☯",
		"♠",
		"☆",
		"❄",
		"♫",
		"♫",
		"☯",
		"☆",
		"✈",
		"⍨",
		"♠",
		"♘"
	],
	difficulty: "hard"
},
{
	cards: [
		"⍨",
		"✈",
		"☆",
		"♘",
		"⍨",
		"♫",
		"♠",
		"✈",
		"❄",
		"✈",
		"♘",
		"☆",
		"❄",
		"☯",
		"☯",
		"♫",
		"♠",
		"⍨",
		"☯",
		"☆",
		"❄",
		"♘",
		"♫",
		"♠"
	],
	difficulty: "crazy"
}]
